import dynamic from 'next/dynamic';
import { ComponentConfig } from '@zapier/builder-io-kit-compat';

export const config: ComponentConfig = {
  name: 'Feature Item List',
  description: 'Renders a bulleted list of features.',
  category: 'Zapier Sign Up Blocks',
  // @ts-ignore
  component: dynamic(() =>
    import('@zapier/auth-pages').then(mod => mod.FeatureItemList)
  ),
  canHaveChildren: true,
  childRequirements: {
    component: 'Feature Item',
    message:
      'Only "Feature Item" components can be added to Feature Item List.',
  },
  inputs: [
    {
      name: 'title',
      friendlyName: 'Title',
      type: 'string',
      defaultValue: '',
      helperText: 'Optional',
    },
    {
      name: 'description',
      friendlyName: 'Description',
      type: 'string',
      defaultValue: '',
      helperText: 'Optional',
    },
  ],
};
